import { render } from "./CadastroCidadesView.vue?vue&type=template&id=39829934"
import script from "./CadastroCidadesView.vue?vue&type=script&lang=js"
export * from "./CadastroCidadesView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Garantidoras\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__